module.exports = __webpack_public_path__ + "img/dashboardac.9f153ac3.svg";